import { fetcher } from "helpers/fetcher";

import {
  TGetUserAccociatedBUListReq,
  TGetUserAccociatedBUListRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getUserAssociatedBUList = async (
  params?: TGetUserAccociatedBUListReq,
  language?: string
) => {
  return await fetcher<
    TGetUserAccociatedBUListRes,
    TGetUserAccociatedBUListReq
  >(ENDPOINT.BU.USER_ASSOCIATED_BU_LIST, {
    params: params,
    headers: {
      [API_HEADER.VERSION]: ENDPOINT.BU.USER_ASSOCIATED_BU_LIST.version,
      [API_HEADER.LANGUAGE]: language,
    },
  });
};

export const queryGetUserAssociatedBUList = async (
  params?: TGetUserAccociatedBUListReq,
  language?: string
) => {
  return (await getUserAssociatedBUList(params, language)).data;
};

queryGetUserAssociatedBUList._key = (
  params?: TGetUserAccociatedBUListReq,
  language?: string,
  key?: string
) => [ENDPOINT.BU.USER_ASSOCIATED_BU_LIST.url, params, language, key];
